import {
  IPaymentData,
  IVoucherData,
  IReplenishmentsPayload,
  IReplenishmentsResponse,
  IReplenishmentResponse,
  IReplenishmentResponseMeta
} from '@/interfaces/replenishments'
import apiClient from '@/utils/request'
import { nestedQueryFormatter } from '@/utils/query'
export const fetchItems = async (
  payload: IReplenishmentsPayload
): Promise<IReplenishmentsResponse> => {
  const filter =
    payload.filter?.online === false
      ? { ...payload.filter, online: 'false' }
      : payload.filter
  const params = Object.assign(
    { limit: payload.limit, start: payload.start },
    nestedQueryFormatter('filter', filter),
    nestedQueryFormatter('sorter', { direction: 'desc', field: 'created_at' })
  )
  const response = await apiClient.get<IReplenishmentsResponse>(
    '/replenishments',
    { params }
  )
  return response.data
}

export const createItem = async (
  payload: IPaymentData
): Promise<IReplenishmentResponseMeta> => {
  const response = await apiClient.post<IReplenishmentResponse>(
    '/replenishments',
    payload
  )
  return response.data.meta
}

export const activateVoucher = async (
  payload: IVoucherData
): Promise<IReplenishmentResponseMeta> => {
  const response = await apiClient.post<IReplenishmentResponse>(
    '/vouchers',
    payload
  )
  return response.data.meta
}
